/* eslint-disable */
import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  styles: {
    global: {
      body: {
        backgroundColor: "brand.background",
        fontFamily: "ABeeZee",
        color: "brand.text",
      },
    },
  },
  colors: {
    brand: {
      /* Light colors */
      bf4Light1: "#FE7098",
      bf4Light2: "#D370A9",
      bf4Light3: "#9A70BA",
      bf4Light4: "#7070A6",

      /* Main colors */
      bf4: "#000060",
      bf3: "#4C0084",
      bf2: "#AE0064",
      bf1: "#FF004A",
      inputBackground: "#FAFCFE",
      inputBorder: "#97A0C3",

      /* Others */
      black: "#000000",
      text: "#242F57",
      grey: "#97A0C3",
      white: "#ffffff",
      background: "#F4F7FC",
      bgDisabled: "rgba(245, 246, 255, 0.5)",
    },
  },
  heading: "ABeeZee",
  body: "ABeeZee",
  components: {
    Button: {
      variants: {
        "b4f-outline": {
          bg: "none",
          borderColor: "brand.bf2",
          borderWidth: "1px",
          color: "brand.bf2",
          fontWeight: "normal",
          borderRadius: "10px",
          _hover: {
            bg: "brand.bf2",
            color: "white",
          },
          _disabled: {
            color: "brand.grey",
            borderColor: "brand.grey",
          },
        },
        b4f: {
          bg: "brand.bf2",
          color: "white",
          padding: "8px 30px",
          borderRadius: "10px",
          fontWeight: "normal",
          _hover: {
            bg: "brand.bf4Light2",
          },
        },
      },
    },
    Heading: {
      variants: {
        "b4f-subSection": {
          fontSize: "16px",
          color: "brand.bf3",
          fontWeight: "normal",
          marginBottom: "20px",
          fontFamily: "ABeeZee",
        },
      },
    },
  },
});

export default theme;
